module.exports = __webpack_public_path__ + "assets/lock.58cfc5ad.svg";